import { ICustomPagePagedRequest } from '../../../../model/apm/custom-page/request/custom-page-paged-request';

export type CustomPageSearchState = {
    parameters: ICustomPagePagedRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const CustomPageSearchReducer = (state: CustomPageSearchState, action: any): CustomPageSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
